import React from "react";
import classNames from "classnames/bind";
import styles from "./PrivacyPolicy.module.scss";
import parse from "html-react-parser";

const cx = classNames.bind(styles);

export default function PrivacyPolicy({ data }) {
  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("header-box")}>
          <p className={cx("title")}>개인정보 처리방침</p>
        </div>
        <div className={cx("content")}>{parse(data || "-")}</div>
      </div>
    </div>
  );
}
